import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, children, className = "" }) => (
  <div className={className}>
    <Reveal>
      <p className="text-xs sm:text-sm uppercase tracking-[0.25em] font-bold text-volt mb-5">
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-8xl">
        {children}
      </h2>
    </Reveal>
  </div>
);
